<template>
  <van-tabbar v-model="actives" active-color="red">
    <van-tabbar-item icon="wap-home-o" @click="goHref(1)">首页</van-tabbar-item>
    <van-tabbar-item icon="user-o" @click="goHref(2)">我的</van-tabbar-item>
  </van-tabbar>
</template>

<script>
import {Tabbar, TabbarItem} from 'vant';
import {Toast, Dialog} from 'vant'

export default {
  name: 'Footer',
  props: {
    active: {
      type: Number,
      default: 0
    },
    isLogin:{
      type: Boolean,
      default: false
    },
  },
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem
  },

  data() {
    return {
      actives: this.active
    };
  },
  methods: {
    goHref(type) {
      if (type == 1) {
        this.$router.push({name: 'main'});
      } else if (type == 2) {
        if (this.isLogin) {
          this.$router.push({name: 'userCenter'});
        } else {
          Dialog.confirm({
            message: '您还没有登录，是否需要跳转登录？',
          }).then(() => {
            window.location.href = "/checkLogin?urls=" + encodeURI(window.location.href);
          }).catch(() => {
          });
        }
      }
    }
  }


};
</script>

<style lang="less">
</style>
